import React, { Component } from 'react';

export default class StarsContent extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
          <div>
            <p>
              Node is a project that I worked on as part of a team of 11 for the Global Game Jam 2017. The game was developed, from pen and paper prototype to downloadable game (and trailer!) in less than 48 hours. After the game jam, a few members of the team presented Node at the Mass.
DiGi 2017 Game Challenge, where Node won the <i>Best Design</i> and <i>College Alpha Category Runner-Up</i> awards!
            </p>

            <p>
              The idea for the game came from the prompt for the Global Game Jam, “waves.” This was a very open-ended prompt, and the team decided to roll with the idea of sound/magnetic waves to create a puzzle game.
            </p>

            <p>
              Node is simple - click on the different nodes to activate/deactivate them in order to maneuver the balls into the goal area. Some nodes attract the balls, and some repel them; some nodes are toggled on/off with a click, while others must be clicked and held down. This allowed us a lot of freedom in the level design process because this gave us a way to make the puzzle more engaging. If the nodes were only toggles, the user would just need to flip all of the correct switches, but with the click-and-hold nodes, we can make player have to manage their time, and quickly switch from node to node to keep the correct ones on or off.
            </p>

            <p>
              After the base gameplay systems were introduced, we were able to devote a lot of our time to designing all of the levels. The developers, artists, and designers were all able to design levels for the game, which I really enjoyed and made the scripting work a lot more fulfilling.
            </p>

            <p>
              After designing a few levels, I focused on coding the audio for the game, adding in sound effects and music. I also lead the effort to storyboard the trailer, and recording and edited together the clips for our trailer before the final deadline.
            </p>

            <p>
              Node was my first experience fully developing a digital game, and the weekend of the Global Game Jam was a very busy one, but it’s an experience I will remember forever. If you’re interested in playing node, or learning more about it, click the download or GitHub buttons to the right!
            </p>

          </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/NodeContent.jsx